import { Component, OnInit } from '@angular/core';
import { ScriptsModule } from '../../modules/scripts.module';
import { CurrencyService } from '../../services/currency.service';
import { Cotizacion } from '../../obj/cotizacion';
import { ResCotizacion } from '../../obj/resCotizacion';
import { Compra } from '../../obj/compra';
import { Pasajero } from '../../obj/pasajero';
import { Poliza } from '../../obj/poliza';
import { ActivatedRoute, Router } from '@angular/router';
import { CotizadorService } from '../../services/general/cotizador.service';
import { FormBuilder, FormGroup, FormArray, Validators, ValidatorFn, ValidationErrors, AbstractControl } from '@angular/forms';

declare var jquery: any;
declare var $: any;

@Component({
  selector: 'app-solicitar',
  templateUrl: './solicitar.component.html',
  styleUrls: ['./solicitar.component.css'],
  providers: [CotizadorService]
})
export class SolicitarComponent implements OnInit {
  public modelPoliza;
  public modelCotizacion;
  public model;
  private idTipo;
  private id;

  //NOTIFICACION
  public tituloSolicitar;
  public mensajeSolicitar;
  public rutaSolicitar;
  form: FormGroup;

  public msgError = "";

  constructor(private fb: FormBuilder, public _currencyService: CurrencyService, private route: ActivatedRoute, private router: Router, private cs: CotizadorService) {
    this.form = this.fb.group({
      ceNombre: ['', [Validators.required]],
      ceApellido: ['', [Validators.required]],
      ceTelefono: ['', [Validators.required]],
      ceEmail: ['', [Validators.email, Validators.required]],
      pasajeros: this.fb.array([]), // FormArray para pasajeros
    });
  }


  ngOnInit() {
    // let scripts = new ScriptsModule;
    // scripts.loadScript('assets/js/scripts/solicitar.js');

    var cotizacion = localStorage.getItem('currentCotizacion');
    var poliza = localStorage.getItem('currentPoliza');
    var compra = localStorage.getItem('currentCompra');

    if (compra == null)
      this.model = new Compra();
    else
      this.model = JSON.parse(compra);

    this.route.queryParams.subscribe(params => {
      // Defaults to 0 if no query param provided.
      console.log(params);

      this.model.tipo = params['IdTipo'];
      this.model.id = params['Id'] || params['ID'] || params['id'];

      if (this.model.id != '' && this.model.id !== undefined) {
        this.loadCotizacion(this.model.id, this.model.tipo);
      }
      else {
        this.loadPasajeros(this.model.pasajeros)
        if (cotizacion == null)
          this.router.navigate(['/comparar']);
        else {
          this.modelCotizacion = JSON.parse(cotizacion);
        }

        if (poliza == null)
          this.router.navigate(['/comparar']);
        else {
          this.modelPoliza = JSON.parse(poliza);

        }
      }
      $('#modalupgrade').modal('show');
    });
  }

  get pasajerosArray(): FormArray {
    return this.form.get('pasajeros') as FormArray;
  }


  edadCoincideConEdadIngresada = function (control) {
    const fechaNacimiento = control.get('edadIngresada').value;
    const edad = control.get('edad').value;
    const fecha = control.get('fecha').value;

    if (!fechaNacimiento || !edad) {
      return null; // No validar si falta algún valor
    }

    const birthDate = new Date(fecha)
    const diff_ms = Date.now() - birthDate.getTime();
    const age_dt = new Date(diff_ms);
    let age = Math.abs(age_dt.getUTCFullYear() - 1970);

    const edadCalculada = age;
    // const edadCalculada = calculateAge2(new Date(fechaNacimiento));
    // edad !=NaN && edad == pasajeroPoliza.get('edad').value  && edad<105
    if (!isNaN(edadCalculada) && age == edad && edad < 105) {
      return null
    } else if (!isNaN(edadCalculada) && edad < 105 && edad > 0) {
      return { edadNoCoincide: `Edad calculada (${edadCalculada}) no coincide con la ingresada (${edad})` };
    } else {
      return { fechaInvalida: 'Fecha de nacimiento inválida' };

    }
  };


  calculateAge2(birthDate: Date): number {
    const today = new Date();
    const age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();

    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      return age - 1;
    }
    return age;
  }



  loadPasajeros(pasajerosParams) {
    try {
      //VALIDAMOS PASAJEROS DE LA COMPRA
      // this.model.pasajeros=[];
      const pasajeros = pasajerosParams;
      let destinoDefault = '';
      if (this.model.destino == 21) {
        destinoDefault = 'Colombia'
      }
      // this.upgrade.map(a => { return { ...a, pasajero: []}})

      pasajeros.forEach((pasajero, index) => {
        try {
          // Creamos un FormGroup por cada pasajero
          const pasajeroGroup = this.fb.group({
            numero: [(pasajero.numero || pasajero.Posicion) || ''], // Requerido y solo números],
            edad: [(pasajero.edad || pasajero.Edad) || '', [Validators.required, Validators.min(0), Validators.max(120)]], // Requerido, entre 0 y 120
            edadIngresada: [pasajero.edadIngresada || ''],
            style: [pasajero.style || ''],
            nombre: [pasajero.nombre || '', [Validators.required, Validators.maxLength(100)]], // Requerido, solo letras y espacios
            apellido: [pasajero.apellido || '', [Validators.required, Validators.maxLength(100)]], // Requerido, solo letras y espacios
            documento: [pasajero.documento || '', [Validators.required]], // Requerido, letras mayúsculas y números,
            telefono: [pasajero.telefono || '', [Validators.required, Validators.pattern(/^\+?[0-9\s]+$/)]], // Requerido, permite números y "+" opcional,
            direccion: [pasajero.direccion || '', [Validators.required, Validators.maxLength(200)]], // Requerido, longitud máxima de 200 caracteres,
            email: [pasajero.email || '', [Validators.required, Validators.email]], // Requerido y formato de correo electrónico,
            fecha: [pasajero.fecha || '', [Validators.required]],
            paisDestino: [pasajero.paisDestino || destinoDefault, [Validators.required]], //Requerido, solo letras y espacios
            genero: [(pasajero.genero || pasajero.Gender), [Validators.required]],
            upgrade: [pasajero.upgrade]
          }, { validator: this.edadCoincideConEdadIngresada });

          // Añadimos el pasajero al array
          this.pasajerosArray.push(pasajeroGroup);
        } catch (error) {
          console.error('Error creando pasajero:', error);
        }
      });


    }
    catch (error) { }
  }


  validateField(field: string, pasajero: any): boolean {
    if (pasajero[field].trim() === '') {
      return false;
    }
    return true;
  }

  isEmailValid(email: string): boolean {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  loadCotizacion(id, tipo) {
    var request = { "id": id, "idTipo": tipo };
    //$('#divCargador').show();
    this.cs.getCotizacion(JSON.stringify(request)).then(resp => {
      const d = new Date();
      const dn = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()).getTime();
      const fInisplit = resp.inicio.split('/')
      const fIni = new Date(parseInt(fInisplit[2]), parseInt(fInisplit[1]) - 1, parseInt(fInisplit[0])).getTime()

      //$('#divCargador').hide();
      if (resp.poliza !== undefined && resp.poliza != null) {
        this.model.vencimiento = resp.vencimiento;
        this.model.productoEstado = resp.productoEstado;
        if (this.model.vencimiento > 0 && (this.model.productoEstado == 1 || this.model.productoEstado == 0)) {
          this.model.tipo = tipo;
          this.mensajeSolicitar = "Su cotización ha caducado. Contacte a su asesor para obtener una nueva oferta o aprobar la compra";
          if (tipo != 5) {
            this.rutaSolicitar = "/home";
          }
          else {
            this.rutaSolicitar = "/home";
          }
          $('#modalNotif').modal('show');
          //this.router.navigate(['/comparar']);
        } else if (fIni <= dn) {
          this.model.tipo = tipo;
          this.mensajeSolicitar = "si ya viajaron deben pedir autorización de ventas";
          if (tipo == 5 || tipo == 3 || tipo == 1) {
            this.rutaSolicitar = "/contacto";
          }
          $('#modalNotif').modal({ backdrop: 'static', keyboard: false })
        }
        else if (this.model.productoEstado == 0) {
          this.mensajeSolicitar = "Su cotización ha caducado. Contacte a su asesor para obtener una nueva oferta o aprobar la compra";
          if (this.model.tipo != 5) {
            this.rutaSolicitar = "/home";
          }
          else {
            this.rutaSolicitar = "/home";
          }
          $('#modalNotif').modal('show');
          //this.router.navigate(['/comparar']);

        }
        this.modelCotizacion = new Cotizacion(48, 1, 11, '', '', '', 1, '', '', '', '', '', '', '', '', '', '', false);
        this.modelPoliza = new Poliza('', '', '', '', '', '', '');
        //COTIZACION
        var edad = resp.edades.replace(/,/g, ' ');
        const edades = edad.split(' ').map((a, index) => { return { Edad: a, Gender: 0, Posicion: (index + 1) } })

        this.modelCotizacion.inicio = resp.inicio;
        this.modelCotizacion.fin = resp.fin;
        this.modelCotizacion.origen = resp.origen;
        this.modelCotizacion.destino = resp.destino;
        this.modelCotizacion.tipo = resp.tipo;
        this.modelCotizacion.nombreOrigen = resp.nombreOrigen;
        this.modelCotizacion.nombreDestino = resp.nombreDestino;
        this.modelCotizacion.terminos = true;
        this.modelCotizacion.pasajerosArray = edades;
        this.modelCotizacion.pasajerosArrayCopia = edades;
        const pasajerosData =
          typeof this.modelCotizacion.pasajerosArray === "string"
            ? JSON.parse(this.modelCotizacion.pasajerosArray) // Convertir solo si es una cadena
            : this.modelCotizacion.pasajerosArray; // Usar directamente si ya es un objeto

        console.log(pasajerosData);
        this.loadPasajeros(pasajerosData);

        //COMPRA
        this.model.tipo = tipo;
        this.model.usuario = resp.idUsuario;
        this.model.idReferencia = resp.idReferencia;
        this.model.intermediario = resp.idIntermediario;
        //POLIZA
        this.modelPoliza = resp.poliza;
        this.modelPoliza.cantidadPasajeros = resp.pasajeros;
        this.modelPoliza.nombre = resp.plan;
        this.modelPoliza.id = resp.idPoliza;
        this.modelPoliza.precioCop = resp.precioCop;
        this.modelPoliza.precio = resp.precio;
        this.modelPoliza.trm = resp.trm;
        this.modelPoliza.edades = resp.edades;
        this.modelPoliza.imagen = resp.imagen;

        localStorage.setItem('currentPoliza', JSON.stringify(this.modelPoliza));
        localStorage.setItem('currentCotizacion', JSON.stringify(this.modelCotizacion));

      }
      else {
        this.mensajeSolicitar = "La cotización ha sido eliminada,solicite una nueva cotización!!";
        this.rutaSolicitar = "/home";
        $('#modalNotif').modal('show');
        //this.router.navigate(['/comparar']);

        this.modelCotizacion = new Cotizacion(48, 1, 11, '', '', '', 1, '', '', '', '', '', '', '', '', '', '', false);
        this.modelPoliza = new Poliza('', '', '', '', '', '', '');
        this.modelPoliza.precioCop = 0;
        this.modelPoliza.precio = 0;
      }

    });
  }
  quitarUpgrade(posicion, upgrade) {
    for (let i = 0; i < this.model.pasajeros.length; i++) {
      this.model.pasajeros[this.model.pasajeros.findIndex(a => a.numero == posicion)].upgrade.find(a => a.Id == upgrade.Id)['montoPasajero' + i] = "";
      this.model.pasajeros[this.model.pasajeros.findIndex(a => a.numero == posicion)].upgrade.find(a => a.Id == upgrade.Id)['monto'] = "";
    }
    this.model.pasajeros[this.model.pasajeros.findIndex(a => a.numero == posicion)].upgrade.splice(this.model.pasajeros[this.model.pasajeros.findIndex(a => a.numero == posicion)].upgrade.findIndex(a => a.Id == upgrade.Id), 1)
    // this.precioUpgrade();
  }
  validar() {
    if (this.form.valid) {
      this.onSubmit()
    }
  }

  onSubmit() {

    this.model.medioPago = "1";//por defecto tarjeta de credito
    this.model.idPoliza = this.modelPoliza.id;
    this.model.cop = this.modelPoliza.precioCop;
    this.model.usd = this.modelPoliza.precio;
    this.model.trm = this.modelPoliza.trm;
    this.model.inicio = this.modelCotizacion.inicio;
    this.model.fin = this.modelCotizacion.fin;
    this.model.destino = this.modelCotizacion.destino;

    this.model.ceApellido = this.form.value.ceApellido
    this.model.ceEmail = this.form.value.ceEmail
    this.model.ceNombre = this.form.value.ceNombre
    this.model.ceTelefono = this.form.value.ceTelefono
    this.model.pasajeros = this.form.value.pasajeros

    const currenCompra = JSON.stringify(this.model)
    localStorage.setItem('currentCompra', currenCompra);
    let currentUrl = this.router.url; /// this will give you current url

    let guarda = 0;
    if (this.model.vencimiento > 0 && (this.model.productoEstado == 1 || this.model.productoEstado == 0)) {
      this.mensajeSolicitar = "La cotización ha caducado,cotiza nuevamente más opciones!!";
      if (this.model.tipo != 5) {
        this.rutaSolicitar = "/home";
      }
      else {
        this.rutaSolicitar = "/home";
      }
      $('#modalNotif').modal('show');
      //this.router.navigate(['/comparar']);
      guarda++;
    }
    else if (this.model.productoEstado == 0) {
      this.mensajeSolicitar = "La póliza ya no se encuentra disponible,cotiza nuevamente mas opciones!!";
      if (this.model.tipo != 5) {
        this.rutaSolicitar = "/home";
      }
      else {
        this.rutaSolicitar = "/home";
      }
      $('#modalNotif').modal('show');
      //this.router.navigate(['/comparar']);

    }

    for (var i = 0; i < this.model.pasajeros.length; i++) {
      var pasajero = this.model.pasajeros[i].nombre + " " + this.model.pasajeros[i].apellido;
      try {
        var d = new Date(this.model.pasajeros[i].fecha);
        var edad = this.calculateAge(new Date(this.model.pasajeros[i].fecha));
        var f = this.model.pasajeros[i].fecha;
        if (edad < 100) {
          if (Number(this.model.pasajeros[i].edad) != edad) {
            this.mensajeSolicitar = "La edad del pasajero: (" + pasajero + ") no coincide con la fecha de nacimiento!!";
            $('#modalNotif').modal('show');
            guarda++;
            break;
          }
        }
        else {
          this.mensajeSolicitar = "Debe ingresar una fecha de nacimiento válida para el pasajero: " + pasajero;
          $('#modalNotif').modal('show');
          guarda++;
        }
      }
      catch (error) {
        this.mensajeSolicitar = "Debe ingresar una fecha de nacimiento válida para el pasajero: " + pasajero;
        $('#modalNotif').modal('show');
        guarda++;
      }
    }

    if (guarda == 0) {
      this.router.navigate(['/comprar']);
    }
  }

  calculateAge(dob) {
    var diff_ms = Date.now() - dob.getTime();
    var age_dt = new Date(diff_ms);

    return Math.abs(age_dt.getUTCFullYear() - 1970);
  }

  get currentCompra() { return JSON.stringify(this.model); }

  conversionMonedas(indice: String) {
    let poliza = this.modelPoliza;

    if (poliza) {

      if (this.modelPoliza.conversionMoneda) {
        let coleccion = this.modelPoliza.conversionMoneda;
        let item = coleccion.filter(x => x.id == indice)[0];
        this._currencyService.setValor(item.valor);

        return item.valor;
      }
    }
  }


  dateChanged(arg, pasajeroPoliza) {
    var edad = this.calculateAge(new Date(arg.target.value));
    if (!isNaN(edad) && edad == pasajeroPoliza.get('edad').value && edad < 105) {
      pasajeroPoliza.get('edadIngresada').setValue(edad);
      pasajeroPoliza.get('edadIngresada').setValue(`Fecha de nacimiento válida`)
      pasajeroPoliza.get('style').setValue('5px solid #5cb85c');
    }
    else if (!isNaN(edad) && edad < 105 && edad > 0) {
      pasajeroPoliza.get('edadIngresada').setValue(`Fecha de nacimiento inválida (Edad: ${edad})`)
      pasajeroPoliza.get('style').setValue('5px solid red');
    }
    else {
      pasajeroPoliza.get('edadIngresada').setValue(`Fecha de nacimiento inválida `)
      pasajeroPoliza.get('style').setValue('5px solid red');
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/solicitar/solicitar.component.ts